<template>
  <CustomDrawer
    v-model:modelValue="internalDrawerVisible"
    direction="right"
    width="600px"
    title="Get New Number"
  >
    <AddPhoneNumberContent
      ref="contentRef"
      :source="source"
      @complete="handleComplete"
    />

    <template #footer>
      <div class="flex flex-row gap-2 justify-end">
        <a-button
          class="primary_medium"
          @click="handlePurchase"
          :disabled="!contentRef?.canPurchase"
          :loading="contentRef?.purchasingNumber"
        >
          {{ contentRef?.purchasingNumber ? "Purchasing" : "Confirm Number" }}
        </a-button>
      </div>
    </template>
  </CustomDrawer>
</template>

<script setup>
import { ref, watch } from "vue";
import CustomDrawer from "@/src/components/CustomDrawer.vue";
import AddPhoneNumberContent from "@/src/components/telephony_components/phone_number/AddPhoneNumberContent.vue";

const props = defineProps({
  source: { type: String, required: true },
  drawerVisible: { type: Boolean, required: true },
});

const emit = defineEmits(["update:modelValue", "complete"]);

const contentRef = ref(null);
const internalDrawerVisible = ref(props.drawerVisible);

const handlePurchase = async () => {
  await contentRef.value?.toPurchasePhoneNumber();
};

const handleComplete = (data) => {
  internalDrawerVisible.value = false;
  emit("complete", data?.subAccountCreated || false);
};

watch(
  () => props.drawerVisible,
  (newVal) => {
    internalDrawerVisible.value = newVal;
  },
);

watch(
  () => internalDrawerVisible.value,
  (newVal) => {
    if (!newVal) {
      contentRef.value?.resetFormData();
      emit("update:modelValue", false);
    }
  },
);
</script>
